var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OptionBoxHoverWrapper, OptionBoxWrapper, OptionsBoxListWrapper, OptionsBoxWrapper } from '../styles';
import React from 'react';
import { Colors, FInter } from '@brg/ui';
/**
 * Опция
 *
 * @param innerRef
 * @param innerProps
 * @param children
 * @param isFocused
 * @constructor
 */
export var OptionBox = function (_a) {
    var innerRef = _a.innerRef, innerProps = _a.innerProps, children = _a.children, isFocused = _a.isFocused;
    return isFocused ? (React.createElement(OptionBoxHoverWrapper, __assign({}, innerRef, innerProps), children)) : (React.createElement(OptionBoxWrapper, __assign({}, innerRef, innerProps), children));
};
//
// Разницу между этими двумя компонентами я не очень полян. Но пусть будет
//
export var OptionsBox = function (props) {
    var innerRef = props.innerRef, innerProps = props.innerProps, children = props.children;
    return (React.createElement(OptionsBoxWrapper, __assign({ ref: innerRef }, innerProps), children));
};
export var OptionsListBox = function (_a) {
    var innerRef = _a.innerRef, children = _a.children;
    return (React.createElement(OptionsBoxListWrapper, { ref: innerRef }, children));
};
/**
 * Сообщение что ничего не найдено
 * @constructor
 */
export var NoOptionsMessage = function () {
    return (React.createElement(FInter.SmallTextFlex, { color: Colors.geoWhite31, style: { paddingLeft: '16px' }, height: 48, align: 'center' }, "No such position"));
};
//# sourceMappingURL=OptionsBox.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OptionBoxHoverWrapper, OptionBoxWrapper, OptionsBoxListWrapper, OptionsBoxWrapper } from '../styles';
import React from 'react';
import { Colors, FInter } from '@brg/ui';
/**
 * Опция
 *
 * @param innerRef
 * @param innerProps
 * @param children
 * @param isFocused
 * @constructor
 */
export var OptionBox = function (_a) {
    var innerRef = _a.innerRef, innerProps = _a.innerProps, children = _a.children, isFocused = _a.isFocused;
    return isFocused ? (React.createElement(OptionBoxHoverWrapper, __assign({}, innerRef, innerProps), children)) : (React.createElement(OptionBoxWrapper, __assign({}, innerRef, innerProps), children));
};
//
// Разницу между этими двумя компонентами я не очень полян. Но пусть будет
//
export var OptionsBox = function (props) {
    var innerRef = props.innerRef, innerProps = props.innerProps, children = props.children;
    return (React.createElement(OptionsBoxWrapper, __assign({ ref: innerRef }, innerProps), children));
};
export var OptionsListBox = function (_a) {
    var innerRef = _a.innerRef, children = _a.children;
    return (React.createElement(OptionsBoxListWrapper, { ref: innerRef }, children));
};
/**
 * Сообщение что ничего не найдено
 * @constructor
 */
export var NoOptionsMessage = function () {
    return (React.createElement(FInter.SmallTextFlex, { color: Colors.geoWhite31, style: { paddingLeft: '16px' }, height: 48, align: 'center' }, "No such position"));
};
//# sourceMappingURL=OptionsBox.js.map